import { connect } from 'react-redux';
import { deleteCard } from '../../../../actions/deleteCard';
import { deletePrimaryCard } from '../../../../actions/deletePrimaryCard';
import { hideRemovalConfirmation, showRemovalConfirmation } from '../../../../actions/ui';
import { selectAppSessionId, selectRemoveLoading, selectViewMode } from '../../../../selectors/appState';
import { selectExpandedCard, selectPrimaryCard } from '../../../../selectors/creditCard';
import { selectDeviceType, selectMobileType } from '../../../../selectors/deviceType';
import { selectShowRemovalConfirmation } from '../../../../selectors/ui';
import { IStoreState } from '../../../../types/StoreState';
import { ActionButtonsController } from './controller';

export const ActionButtonsControllerConnect = connect(
  (state: IStoreState) => ({
    viewMode: selectViewMode(state),
    showRemoveConfirmation: selectShowRemovalConfirmation(state),
    primaryCardId: selectPrimaryCard(state)?.creditCardId,
    card: selectExpandedCard(state),
    mobile: selectMobileType(state),
    isRemovingInProcess: selectRemoveLoading(state),
    deviceType: selectDeviceType(state),
    appSessionId: selectAppSessionId(state),
  }),
  {
    deleteCard,
    deletePrimaryCard,
    requestRemoval: showRemovalConfirmation,
    declineRemoval: hideRemovalConfirmation,
  },
)(ActionButtonsController);
